import { z } from 'zod'

import { AuthenticationSchema } from '@mntn-dev/authentication-types'
import { AuthorizationSchema } from '@mntn-dev/authorization-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { ProfileSchema } from './profile.ts'

export const UnauthenticatedSessionSchema = z.object({
  authn: AuthenticationSchema.optional(),
  authz: AuthorizationSchema.optional(),
  profile: ProfileSchema.optional(),
})

export type UnauthenticatedSession = ZodInfer<
  typeof UnauthenticatedSessionSchema
>

export const AuthenticatedSessionSchema = UnauthenticatedSessionSchema.required(
  {
    authn: true,
  }
)

export type AuthenticatedSession = ZodInfer<typeof AuthenticatedSessionSchema>

export const AuthorizedSessionSchema = AuthenticatedSessionSchema.required({
  authz: true,
  profile: true,
})

export type AuthorizedSession = ZodInfer<typeof AuthorizedSessionSchema>
